export const isStringValueEmpty = (value?: string | null): boolean =>
  !value || value.trim?.().length === 0
export const isNumericValueValid = (value?: number): boolean => typeof value === 'number'
